<script lang="ts" setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M0 13.9956V14.25C0 14.8099 0.22242 15.3469 0.61833 15.7428C1.01424 16.1387 1.55121 16.3611 2.11111 16.3611H16.8889C17.4488 16.3611 17.9858 16.1387 18.3817 15.7428C18.7776 15.3469 19 14.8099 19 14.25V13.9956H0Z"
      fill="#A7122D"
    />
    <path d="M0 11.7065H19V14.0736H0V11.7065Z" fill="#EEEEEE" />
    <path d="M0 7.13184H19V11.7874H0V7.13184Z" fill="#292648" />
    <path d="M0 4.84546H19V7.21254H0V4.84546Z" fill="#EEEEEE" />
    <path
      d="M0 4.92578V4.75003C0 4.19013 0.22242 3.65316 0.61833 3.25725C1.01424 2.86134 1.55121 2.63892 2.11111 2.63892H16.8889C17.4488 2.63892 17.9858 2.86134 18.3817 3.25725C18.7776 3.65316 19 4.19013 19 4.75003V4.92578H0Z"
      fill="#A7122D"
    />
  </svg>
</template>
